function KeyGenerationModalController() {
  const ctrl = this;
  ctrl.$onInit = () => {
    ctrl.key = ctrl.resolve.key;
    ctrl.keyTypes = [
      {
        name: 'Maintenance laptop SSH key',
        type: 'SSH',
        target: 'TRAIN',
        description: '',
        selected: false,
        disabled: false
      },
      {
        name: 'SmartVision identification key',
        type: 'RSA',
        target: 'SMARTVISION',
        description: '',
        selected: false,
        disabled: false
      },
      {
        name: 'Train identification key',
        type: 'RSA',
        target: 'TRAIN',
        description: '',
        selected: false,
        disabled: false
      },
      {
        name: 'WIFI Access Radius Certificate',
        type: '', // TODO: Needs type
        target: '',
        description: '',
        selected: false,
        disabled: true
      },
      {
        name: 'EKE Build system update packages key',
        type: '', // TODO: Needs type
        target: '',
        description: '',
        selected: false,
        disabled: true
      },
      {
        name: 'SmartVision Build system update packages key',
        type: '', // TODO: Needs type
        target: '',
        description: '',
        selected: false,
        disabled: true
      },
    ];
  };

  ctrl.select = key => {
    ctrl.keyTypes.map(k => k.selected = false);
    ctrl.keySelected = key;
    key.selected = true;
  };

  ctrl.confirmGeneration = () => {
    ctrl.close({ $value: ctrl.keySelected });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('modalDirectives')
  .controller('KeyGenerationModalController', KeyGenerationModalController);
